import { render } from "./index.vue?vue&type=template&id=a8ec80d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a8ec80d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8ec80d0"

export default script